import React from 'react';
import PropTypes from 'prop-types';

import HintText from '../HintText';
import Tooltip from '../Tooltip';
import InfoIcon from '../InfoIcon';

const HintTextWithTooltip = ({ title, text }) => {
  return (
    <Tooltip show title={title}>
      <span>
        <HintText text={text} /> <InfoIcon />
      </span>
    </Tooltip>
  );
};

HintTextWithTooltip.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string.isRequired
};

export default HintTextWithTooltip;
